import { render, staticRenderFns } from "./PedidoDetail.vue?vue&type=template&id=092add40&scoped=true"
import script from "./PedidoDetail.vue?vue&type=script&lang=js"
export * from "./PedidoDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "092add40",
  null
  
)

export default component.exports